// Shared PDF generation utility for VowAI Timeline
export const generateTimelinePDF = (timeline, timelineName, weddingDate) => {
  const printWindow = window.open('', '_blank');
  const weddingDateFormatted = weddingDate ? new Date(weddingDate).toLocaleDateString('en-US', { 
    weekday: 'long', 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  }) : 'Your Wedding Day';
  
  const htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <title>VowAI Wedding Timeline - ${timelineName || weddingDateFormatted}</title>
      <style>
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700;900&family=Cormorant+Garamond:wght@300;400;600;700&family=Montserrat:wght@300;400;600&display=swap');
        
        @page {
          size: A4;
          margin: 15mm;
        }
        
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        
        body {
          font-family: 'Montserrat', sans-serif;
          background: linear-gradient(135deg, #fff5f7 0%, #ffe8f0 50%, #fff9e6 100%);
          padding: 30px 20px;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
          color-adjust: exact !important;
        }
        
        .page {
          max-width: 800px;
          margin: 0 auto;
          background: white;
          border-radius: 24px;
          padding: 50px 45px;
          box-shadow: 0 30px 80px rgba(0,0,0,0.12);
          position: relative;
          overflow: hidden;
        }
        
        .content {
          position: relative;
          z-index: 10;
        }
        
        .header {
          text-align: center;
          margin-bottom: 50px;
          padding-bottom: 30px;
          position: relative;
        }
        
        .header::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 200px;
          height: 3px;
          background: linear-gradient(90deg, transparent, #d4af37, transparent);
        }
        
        .logo {
          font-family: 'Playfair Display', serif;
          font-size: 52px;
          font-weight: 900;
          background: linear-gradient(135deg, #ec4899 0%, #8b5cf6 50%, #d4af37 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-bottom: 15px;
          letter-spacing: 4px;
        }
        
        .subtitle {
          font-family: 'Cormorant Garamond', serif;
          font-size: 28px;
          color: #6b7280;
          font-weight: 400;
          font-style: italic;
          margin-bottom: 18px;
        }
        
        .wedding-date {
          font-size: 15px;
          color: #9ca3af;
          font-weight: 600;
          letter-spacing: 2px;
          text-transform: uppercase;
        }
        
        .day-divider {
          text-align: center;
          margin: 50px 0 40px 0;
          position: relative;
        }
        
        .day-badge {
          display: inline-block;
          background: linear-gradient(135deg, #d4af37 0%, #f59e0b 100%);
          color: white;
          padding: 12px 40px;
          border-radius: 50px;
          font-weight: 700;
          font-size: 15px;
          letter-spacing: 2px;
          box-shadow: 0 8px 25px rgba(212, 175, 55, 0.4);
          text-transform: uppercase;
        }
        
        .timeline {
          position: relative;
          padding-left: 55px;
        }
        
        .timeline::before {
          content: '';
          position: absolute;
          left: 20px;
          top: 0;
          bottom: 0;
          width: 4px;
          background: linear-gradient(180deg, #ec4899 0%, #8b5cf6 50%, #d4af37 100%);
          border-radius: 4px;
        }
        
        .event-item {
          position: relative;
          margin-bottom: 32px;
          page-break-inside: avoid;
        }
        
        .event-dot {
          position: absolute;
          left: -45px;
          top: 8px;
          width: 20px;
          height: 20px;
          background: white;
          border: 4px solid #d4af37;
          border-radius: 50%;
          box-shadow: 0 4px 12px rgba(212, 175, 55, 0.5);
          z-index: 2;
        }
        
        .event-card {
          background: linear-gradient(135deg, #ffffff 0%, #fef3f8 100%);
          border: 2px solid #fce7f3;
          border-radius: 16px;
          padding: 22px 26px;
          box-shadow: 0 6px 20px rgba(236, 72, 153, 0.1);
          position: relative;
        }
        
        .event-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #ec4899, #8b5cf6, #d4af37);
          border-radius: 16px 16px 0 0;
        }
        
        .event-header {
          display: flex;
          align-items: center;
          gap: 16px;
          margin-bottom: 12px;
        }
        
        .event-icon {
          font-size: 36px;
          filter: drop-shadow(0 3px 6px rgba(0,0,0,0.15));
        }
        
        .event-info {
          flex: 1;
        }
        
        .event-name {
          font-family: 'Cormorant Garamond', serif;
          font-size: 22px;
          font-weight: 700;
          color: #1f2937;
          margin-bottom: 5px;
          line-height: 1.3;
        }
        
        .event-time {
          font-size: 15px;
          font-weight: 600;
          background: linear-gradient(135deg, #8b5cf6 0%, #ec4899 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          letter-spacing: 1px;
        }
        
        .event-description {
          color: #6b7280;
          font-size: 14px;
          line-height: 1.7;
          margin-top: 10px;
          padding-left: 52px;
        }
        
        .event-badges {
          display: flex;
          gap: 8px;
          margin-top: 14px;
          padding-left: 52px;
        }
        
        .badge {
          padding: 5px 14px;
          border-radius: 20px;
          font-size: 11px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        .badge-custom {
          background: linear-gradient(135deg, #3b82f6 0%, #06b6d4 100%);
          color: white;
        }
        
        .badge-ritual {
          background: linear-gradient(135deg, #8b5cf6 0%, #ec4899 100%);
          color: white;
        }
        
        .badge-culture {
          background: linear-gradient(135deg, #f59e0b 0%, #d4af37 100%);
          color: white;
          font-size: 10px;
        }
        
        .footer {
          margin-top: 60px;
          padding-top: 35px;
          text-align: center;
          position: relative;
        }
        
        .footer::before {
          content: '';
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 200px;
          height: 3px;
          background: linear-gradient(90deg, transparent, #d4af37, transparent);
        }
        
        .footer-logo {
          font-family: 'Playfair Display', serif;
          font-weight: 900;
          background: linear-gradient(135deg, #ec4899 0%, #8b5cf6 50%, #d4af37 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          font-size: 26px;
          margin-bottom: 8px;
          letter-spacing: 3px;
        }
        
        .footer-tagline {
          font-family: 'Cormorant Garamond', serif;
          color: #9ca3af;
          font-size: 16px;
          font-style: italic;
          font-weight: 300;
        }
        
        @media print {
          body {
            background: white;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }
          
          .page {
            box-shadow: none;
            padding: 40px 35px;
          }
        }
      </style>
    </head>
    <body>
      <div class="page">
        <!-- Decorative corners with inline styles for print -->
        <div style="position:absolute;top:20px;left:20px;font-size:70px;opacity:0.12;z-index:1">✨</div>
        <div style="position:absolute;top:20px;right:20px;font-size:70px;opacity:0.12;z-index:1">💕</div>
        <div style="position:absolute;bottom:20px;left:20px;font-size:70px;opacity:0.12;z-index:1">🌸</div>
        <div style="position:absolute;bottom:20px;right:20px;font-size:70px;opacity:0.12;z-index:1">💐</div>
        
        <!-- Floating sparkles -->
        <div style="position:absolute;top:15%;left:10%;font-size:22px;opacity:0.08;z-index:1">⭐</div>
        <div style="position:absolute;top:30%;right:12%;font-size:18px;opacity:0.08;z-index:1">💫</div>
        <div style="position:absolute;top:50%;left:8%;font-size:20px;opacity:0.08;z-index:1">✨</div>
        <div style="position:absolute;top:70%;right:10%;font-size:22px;opacity:0.08;z-index:1">🌟</div>
        <div style="position:absolute;bottom:15%;left:12%;font-size:18px;opacity:0.08;z-index:1">💖</div>
        
        <div class="content">
          <div class="header">
            <div class="logo">VowAI</div>
            <div class="subtitle">${timelineName || 'Wedding Timeline'}</div>
            <div class="wedding-date">${weddingDateFormatted}</div>
          </div>
          
          <div class="timeline">
            ${timeline.map((item, index) => {
              const showDateLabel = item.dateLabel && (index === 0 || timeline[index - 1].dateLabel !== item.dateLabel);
              return `
                ${showDateLabel ? `<div class="day-divider"><div class="day-badge">📅 ${item.dateLabel}${item.date ? ` - ${new Date(item.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}` : ''}</div></div>` : ''}
                <div class="event-item">
                  <div class="event-dot"></div>
                  <div class="event-card">
                    <div class="event-header">
                      <div class="event-icon">${item.icon}</div>
                      <div class="event-info">
                        <div class="event-name">${item.event}</div>
                        <div class="event-time">${item.time}</div>
                      </div>
                    </div>
                    ${item.description ? `<div class="event-description">${item.description}</div>` : ''}
                    <div class="event-badges">
                      ${item.isCustom ? '<span class="badge badge-custom">Custom</span>' : ''}
                      ${item.isRitual ? '<span class="badge badge-ritual">Ritual</span>' : ''}
                      ${item.culture_display_name ? `<span class="badge badge-culture">${item.culture_display_name}</span>` : ''}
                    </div>
                  </div>
                </div>
              `;
            }).join('')}
          </div>
          
          <div class="footer">
            <div class="footer-logo">VowAI</div>
            <div class="footer-tagline">Your perfect day, perfectly planned</div>
          </div>
        </div>
      </div>
      
      <script>
        window.onload = function() {
          setTimeout(function() {
            window.print();
          }, 500);
        };
      </script>
    </body>
    </html>
  `;
  
  printWindow.document.write(htmlContent);
  printWindow.document.close();
};

// Shared PDF generation utility for VowAI Thank You Notes
export const generateThankYouPDF = (noteContent, coupleNames, weddingImage) => {
  const printWindow = window.open('', '_blank');
  
  const htmlContent = `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Thank You Note - ${coupleNames}</title>
  <link href="https://fonts.googleapis.com/css2?family=Great+Vibes&family=Cormorant+Garamond:wght@300;400;600&family=Allura&display=swap" rel="stylesheet">
  <style>
    @page {
      size: A4;
      margin: 0.5cm;
    }
    
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }
    
    body {
      font-family: 'Cormorant Garamond', serif;
      background: linear-gradient(135deg, #fff5f7 0%, #ffe8f0 50%, #fff9e6 100%);
      padding: 40px 20px;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
      color-adjust: exact !important;
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .thank-you-card {
      display: flex;
      width: 721px;
      height: 508px;
      margin: 0 auto;
      background: white;
      border-radius: 24px;
      overflow: hidden;
      box-shadow: 0 30px 80px rgba(0,0,0,0.15);
      position: relative;
    }
    
    .thank-you-card::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 150px;
      height: 150px;
      background: radial-gradient(circle at top left, rgba(236, 72, 153, 0.1) 0%, transparent 70%);
      pointer-events: none;
      z-index: 1;
    }
    
    .thank-you-card::after {
      content: '';
      position: absolute;
      bottom: 0;
      right: 0;
      width: 150px;
      height: 150px;
      background: radial-gradient(circle at bottom right, rgba(212, 175, 55, 0.1) 0%, transparent 70%);
      pointer-events: none;
      z-index: 1;
    }
    
    .image-section {
      flex: 1;
      overflow: hidden;
      background: linear-gradient(135deg, #fce4ec 0%, #f8bbd0 100%);
      position: relative;
    }
    
    .image-section img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      image-rendering: high-quality;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
    }
    
    .image-section::after {
      content: '';
      position: absolute;
      top: 20px;
      left: 20px;
      right: 20px;
      bottom: 20px;
      border: 2px solid rgba(255, 255, 255, 0.3);
      border-radius: 12px;
      pointer-events: none;
    }
    
    .text-section {
      flex: 1;
      padding: 30px 25px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      background: linear-gradient(135deg, #fff5f7 0%, #ffe8f0 100%);
      text-align: center;
      position: relative;
      z-index: 2;
    }
    
    .text-section::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-image: 
        radial-gradient(circle at 20% 30%, rgba(236, 72, 153, 0.03) 0%, transparent 50%),
        radial-gradient(circle at 80% 70%, rgba(212, 175, 55, 0.03) 0%, transparent 50%);
      pointer-events: none;
      z-index: -1;
    }
    
    .thank-you-header {
      font-family: 'Great Vibes', 'Allura', cursive;
      font-size: 40px;
      font-weight: 400;
      background: linear-gradient(135deg, #ec4899 0%, #8b5cf6 50%, #d4af37 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      margin-bottom: 16px;
      letter-spacing: 1px;
      text-shadow: 0 2px 4px rgba(0,0,0,0.05);
    }
    
    .text-section pre {
      font-family: 'Allura', 'Great Vibes', cursive;
      font-size: 18px;
      line-height: 1.8;
      color: #444;
      white-space: pre-wrap;
      word-wrap: break-word;
      text-align: center;
      font-weight: 400;
      margin-bottom: 16px;
    }
    
    .signature {
      font-family: 'Allura', 'Great Vibes', cursive;
      font-size: 32px;
      background: linear-gradient(135deg, #ec4899 0%, #d4af37 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      margin-top: 0;
      font-weight: 400;
      letter-spacing: 1px;
    }
    
    .vowai-footer {
      margin-top: 20px;
      padding-top: 20px;
      text-align: center;
      position: relative;
      border-top: 1px solid rgba(212, 175, 55, 0.2);
    }
    
    .vowai-logo {
      font-family: 'Cormorant Garamond', serif;
      font-weight: 600;
      background: linear-gradient(135deg, #ec4899 0%, #8b5cf6 50%, #d4af37 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      font-size: 20px;
      margin-bottom: 8px;
      letter-spacing: 3px;
    }
    
    .vowai-tagline {
      font-size: 12px;
      color: #999;
      font-style: italic;
      letter-spacing: 1px;
      font-weight: 300;
    }
    
    @media print {
      body {
        background: white;
        padding: 0;
      }
      
      .thank-you-card {
        box-shadow: none;
        border-radius: 0;
        width: 721px;
        height: 508px;
      }
    }
    
    @media (max-width: 768px) {
      .thank-you-card {
        flex-direction: column;
        min-height: auto;
      }
      
      .image-section {
        min-height: 400px;
      }
      
      .text-section {
        padding: 60px 40px;
      }
      
      .thank-you-header {
        font-size: 56px;
      }
      
      .text-section pre {
        font-size: 18px;
      }
    }
  </style>
</head>
<body>
  <div class="thank-you-card">
    <div class="image-section">
      ${weddingImage ? '<img src="' + weddingImage + '" alt="Wedding Photo" />' : '<div style="display: flex; align-items: center; justify-content: center; height: 100%; font-size: 72px; opacity: 0.2;">💕</div>'}
    </div>
    <div class="text-section">
      <div class="thank-you-header">Thank You</div>
      <pre>${noteContent}</pre>
      <div class="signature">${coupleNames}</div>
      <div class="vowai-footer">
        <div class="vowai-logo">VowAI</div>
        <div class="vowai-tagline">Your perfect day, perfectly planned</div>
      </div>
    </div>
  </div>
  
  <script>
    window.onload = function() {
      setTimeout(function() {
        window.print();
      }, 1500);
    };
  </script>
</body>
</html>
  `.trim();

  printWindow.document.write(htmlContent);
  printWindow.document.close();
};
